<app-page-header
  [pageTitle]="'Stock de Embriones Congelados'"
  [showCreateButton]="true"
  [textButton]="'Nuevo registro'"
  (onCreateClick)="openCreateVitrificadoModal()"
/>

<app-filters-container
  [hasData]="filas.length > 0"
  [hasActiveFilters]="hasActiveFilters"
  [loading]="loading"
  (clearFilters)="clearFilters()"
>
  @if (!auth.clienteDelUsuario()) {
    <app-filter-select
      selectId="filtro-cliente"
      label="Cliente"
      [options]="clientesOptions"
      [value]="clienteId"
      (valueChange)="onClienteChange($event)"
    />
  }

  <!-- 2026-10-05: sin filtros de OPS; técnica, fechas, donante, toro, rack y estado.
  <app-filter-select
    selectId="filtro-ops-punto"
    label="Punto de OPS"
    [options]="puntosOptions"
    [value]="opsPuntoId"
    (valueChange)="onOpsPuntoChange($event)"
  />

  <app-filter-select
    selectId="filtro-ops-color"
    label="Color de OPS"
    [options]="coloresOptions"
    [value]="opsColorId"
    (valueChange)="onOpsColorChange($event)"
  />
  -->
  <app-filter-select selectId="filtro-tecnica" label="DT / VIT" [options]="opciones.tecnica" [value]="filtros.tecnica"
    (valueChange)="onFiltro('tecnica', $event)" />
  <app-filter-date inputId="filtro-fecha-opu" label="Fecha OPU" [value]="filtros.fechaOpu" (valueChange)="onFiltro('fechaOpu', $event)" />
  <app-filter-date inputId="filtro-fecha-d7" label="Fecha D7" [value]="filtros.fechaD7" (valueChange)="onFiltro('fechaD7', $event)" />
  <app-filter-select selectId="filtro-donante" label="Donante" [options]="opciones.donante" [value]="filtros.donante"
    (valueChange)="onFiltro('donante', $event)" />
  <app-filter-select selectId="filtro-toro" label="Toro" [options]="opciones.toro" [value]="filtros.toro"
    (valueChange)="onFiltro('toro', $event)" />
  <app-filter-select selectId="filtro-rack" label="Rack" [options]="opciones.serieRack" [value]="filtros.serieRack"
    (valueChange)="onFiltro('serieRack', $event)" />
  <app-filter-select selectId="filtro-estado" label="Estado" [options]="opciones.estado" [value]="filtros.estado"
    (valueChange)="onFiltro('estado', $event)" />
</app-filters-container>

<!-- La transferencia se arma desde la tabla: se marcan las pajuelas disponibles y se transfieren. -->
@if (puedeTransferir) {
  <div class="mb-3 flex flex-wrap items-center justify-between gap-3">
    <p class="text-sm text-gray-500 dark:text-gray-400">
      @if (seleccionadas.size > 0) {
        {{ seleccionadas.size }} pajuela(s) marcada(s) · {{ totalEmbrionesSeleccionados }} embrión(es)
        <!-- 2026-09-30: pajuelas de varios clientes pueden ir a la misma TE; el cliente de la TE se elige en el modal.
        @if (clientesSeleccionados > 1) {
          <span class="text-warning-700 dark:text-orange-400"> · son de clientes distintos: una transferencia es de un solo cliente.</span>
        }
        -->
      } @else {
        Marcá las pajuelas disponibles que querés transferir.
      }
    </p>
    <div class="flex flex-wrap items-center gap-2">
      <app-button
        size="sm"
        variant="outline"
        [disabled]="!puedeElegirTodas"
        (btnClick)="toggleSeleccionarDisponibles()"
      >
        Marcar disponibles del cliente
      </app-button>
      <app-button
        size="sm"
        startIcon="move_down"
        [disabled]="seleccionadas.size === 0"
        (btnClick)="transferir()"
      >
        Transferir
        @if (seleccionadas.size > 0) {
          ({{ seleccionadas.size }})
        }
      </app-button>
    </div>
  </div>
}

<app-data-table
  [columns]="columns"
  [data]="filasPagina"
  [loading]="loading"
  [clickableRows]="puedeTransferir"
  (rowClick)="toggleSeleccion($event.item)"
  [compact]="true"
  [footer]="totales"
>
  <ng-template appTableCell="sel" let-item>
    <input
      type="checkbox"
      [checked]="estaSeleccionada(item)"
      [disabled]="item.pajuela.estado !== 'disponible' || !puedeTransferir"
      [attr.aria-label]="'Marcar pajuela ' + item.idOps"
      (click)="$event.stopPropagation()"
      (change)="toggleSeleccion(item)"
    />
  </ng-template>

  <ng-template appTableCell="cliente" let-item>
    <span class="whitespace-nowrap">{{ item.cliente || '-' }}</span>
  </ng-template>

  <!-- 2026-10-01: sin Termo ni Cañas.
  <ng-template appTableCell="termo" let-item>{{ item.termo || '-' }}</ng-template>
  <ng-template appTableCell="canas" let-item>{{ item.canas || '-' }}</ng-template>
  -->

  <ng-template appTableCell="tecnica" let-item>
    @if (item.tecnica) {
      <app-badge [color]="item.tecnica === 'DT' ? 'info' : 'light'" size="sm">{{ item.tecnica }}</app-badge>
    } @else {
      -
    }
  </ng-template>

  <ng-template appTableCell="fecha_opu" let-item>
    <span class="whitespace-nowrap">{{ item.fechaOpu | date:'dd/MM/yyyy' }}</span>
  </ng-template>

  <ng-template appTableCell="fecha_d7" let-item>
    <span class="whitespace-nowrap">{{ item.fechaD7 | date:'dd/MM/yyyy' }}</span>
  </ng-template>

  <ng-template appTableCell="donante" let-item>
    <div class="whitespace-nowrap">
      <div class="font-medium">{{ item.donante }}</div>
      @if (item.razaDonante) {
        <div class="text-xs text-gray-500 dark:text-gray-400">{{ item.razaDonante }}</div>
      }
    </div>
  </ng-template>

  <!-- 2026-10-01: la raza va en la columna de la donante.
  <ng-template appTableCell="raza_donante" let-item>{{ item.razaDonante || '-' }}</ng-template>
  -->

  <ng-template appTableCell="toro" let-item>
    <div class="whitespace-nowrap">
      <div>{{ item.toro || '-' }}</div>
      @if (item.razaToro) {
        <div class="text-xs text-gray-500 dark:text-gray-400">{{ item.razaToro }}</div>
      }
    </div>
  </ng-template>

  <!-- 2026-10-01: la raza va en la columna del toro.
  <ng-template appTableCell="raza_toro" let-item>{{ item.razaToro || '-' }}</ng-template>
  -->

  <ng-template appTableCell="embriones" let-item>{{ item.embriones }}</ng-template>

  <ng-template appTableCell="serie" let-item>
    <span class="whitespace-nowrap">{{ item.serieRack || '-' }}</span>
  </ng-template>

  <ng-template appTableCell="id_ops" let-item>
    <span class="whitespace-nowrap">{{ item.idOps || '-' }}</span>
  </ng-template>

  <ng-template appTableCell="fecha_te" let-item>
    <span class="whitespace-nowrap">{{ item.fechaTe ? (item.fechaTe | date:'dd/MM/yyyy') : '' }}</span>
  </ng-template>

  <ng-template appTableCell="te" let-item>{{ item.te ?? '' }}</ng-template>
  <ng-template appTableCell="perdida" let-item>{{ item.perdida ?? '' }}</ng-template>
  <ng-template appTableCell="saldo" let-item>{{ item.saldo }}</ng-template>

  <ng-template appTableCell="estado" let-item>
    <app-badge
      [color]="item.pajuela.estado === 'disponible' ? 'success' : item.pajuela.estado === 'reservada' ? 'warning' : 'light'"
      size="sm"
    >
      {{ item.estado }}
    </app-badge>
  </ng-template>

  <ng-template appTableCell="destino" let-item>
    <span class="whitespace-nowrap">{{ item.destino }}</span>
  </ng-template>

  <ng-template appTableCell="acciones" let-item>
    <div class="flex items-center gap-x-2.5" (click)="$event.stopPropagation()">
      <!-- Botón de detalle oculto; se deja comentado por si se vuelve a necesitar.
      <button
        type="button"
        [attr.aria-label]="detailTooltip(item.stock)"
        (click)="verDetalleVitrificado(item.stock)"
        [matTooltip]="detailTooltip(item.stock)"
      >
        <mat-icon class="dark:text-gray-400!">visibility</mat-icon>
      </button>
      -->

      @if (item.stock.permite_eliminacion_manual) {
        <app-delete-trigger
          [title]="'Eliminar el registro completo (todas sus pajuelas)'"
          [disabled]="deleting && deletingId === item.stock.id"
          (clickDeleteEvent)="deleteStockVitrificado(item.stock)"
        />
      }
    </div>
  </ng-template>
</app-data-table>

<app-pagination
  [currentPage]="currentPage"
  [lastPage]="lastPage"
  [perPage]="perPage"
  [total]="filas.length"
  (pageChange)="onPageChange($event)"
  (perPageChange)="onPerPageChange($event)"
/>
